import { FuelStatisticEntity, FuelStatisticFilter } from '../../models'

export const SET_FUEL_STATISTIC = 'SET_FUEL_STATISTIC'
export const SET_FUEL_STATISTIC_LOADED = 'SET_FUEL_STATISTIC_LOADED'
export const SET_FUEL_STATISTIC_FILTER = 'SET_FUEL_STATISTIC_FILTER'

export interface FuelStatisticState {
  fuelStatistic: FuelStatisticEntity[]
  isFuelStatisticLoaded: boolean
  fuelStatisticFilter: FuelStatisticFilter
}

interface SetFuelStatisticAction {
  type: typeof SET_FUEL_STATISTIC
  payload: FuelStatisticEntity[]
}

interface SetFuelStatisticLoadedAction {
  type: typeof SET_FUEL_STATISTIC_LOADED
  payload: boolean
}

interface SetFuelStatisticFilterAction {
  type: typeof SET_FUEL_STATISTIC_FILTER
  payload: FuelStatisticFilter
}

export type FuelStatisticAction =
  | SetFuelStatisticAction
  | SetFuelStatisticLoadedAction
  | SetFuelStatisticFilterAction
